import { defineComponent as _defineComponent } from 'vue';
import { BOverlay, BFormRadioGroup, BFormRadio } from 'bootstrap-vue';
import debounce from 'lodash/debounce';
import { computed, onMounted, ref, watch } from 'vue';
import { useAxios } from 'composables/useAxios';
export default /*#__PURE__*/ _defineComponent({
    __name: 'FixingOptions',
    props: {
        value: null,
        groupId: null,
        rebateSize: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const selectedFixing = computed({
            get: () => props.value,
            set: v => emit('input', v)
        });
        const loading = ref(true);
        const maxSqmmForHanger = 205000;
        const stringPrice = ref('0.00');
        const hangerPrice = ref('0.00');
        const diffInPrice = computed(() => {
            const diff = parseFloat(stringPrice.value) - parseFloat(hangerPrice.value);
            const sign = diff > 0 ? '+' : '';
            return `${sign}£${diff.toFixed(2)}`;
        });
        const isHangerDisabled = computed(() => (props.rebateSize.width * props.rebateSize.length) > maxSqmmForHanger);
        const axios = useAxios();
        const updateStringPrice = async () => {
            loading.value = true;
            const { data } = await axios.get('pricing/frame/fixings', {
                params: { width: props.rebateSize.width, length: props.rebateSize.length, valueGroupID: props.groupId }
            });
            stringPrice.value = data.unit_price;
            if (isHangerDisabled.value) {
                emit('input', 'string');
            }
            loading.value = false;
        };
        const debouncedUpdateStringPrice = debounce(updateStringPrice, 350);
        watch(() => props.rebateSize, () => debouncedUpdateStringPrice(), { deep: true });
        onMounted(async () => {
            loading.value = true;
            const { data } = await axios.get('pricing/units/price', { params: { sku: 'FX-46' } });
            hangerPrice.value = data.unit_price;
            updateStringPrice();
        });
        return { __sfc: true, props, emit, selectedFixing, loading, maxSqmmForHanger, stringPrice, hangerPrice, diffInPrice, isHangerDisabled, axios, updateStringPrice, debouncedUpdateStringPrice, BOverlay, BFormRadioGroup, BFormRadio, debounce, computed, onMounted, ref, watch, useAxios };
    }
});
